import { useEffect, useState } from 'react';
import supabase from './supabase';
import './style.css';



const initialFacts = [
  {
    id: 1,
    text: "Budgies can eat a wide variety of fresh fruits and vegetables.They love tropical fruits and can enjoy bananas, apples,berries, melons, cherries, and citrus fruits. Fruits with stones or pits should have them removed before feeding. For vegetables,try small portions of cucumber, lettuce, beets, tomatoes, and celery.",
    source: "https://a-z-animals.com/blog/what-do-budgies-budgerigars-eat-their-diet-explained/",
    category: "Budgie-food",
    votesInteresting: 24,
    votesMindblowing: 9,
    votesFalse: 4,
    createdIn: 2021,
  },
  {
    id: 2,
    text: " Try getting your budgie noisy toys, especially bells, toys that they can perform tricks on, such as swings and ladders, and a nice variety of fun and challenging toys that will keep your budgie busy for hours.",
    source:
      "https://beakcraze.com/best-budgie-toys/",
    category: "Budgie-toys",
    votesInteresting: 11,
    votesMindblowing: 2,
    votesFalse: 0,
    createdIn: 2019,
  },
  {
    id: 3,
    text: "Some Budgies may be sensitive while others might get into mischief at every opportunity.",
    source: "https://www.parrotsecrets.com/Budgie/about-budgie.php",
    category: "Budgie-training",
    votesInteresting: 8,
    votesMindblowing: 3,
    votesFalse: 1,
    createdIn: 2015,
  },
];

function Counter() {
  const [count, setCount] = useState(0);

  return (<div>
    <span style={{fontSize:'40px'}}>{count}</span>
    <button className ='btn btn-large' onClick={()=>setCount((c)=>c+1)}>+1</button>
  </div>
  );
}

function App(){
  const [showForm, setShowForm] = useState(false);
  const [facts, setFacts] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const[currentCategory, setCurrentCategory]=useState("all");
  
  useEffect(function() {
   async function getFacts() {
    setisLoading(true);

    let query = supabase.from('facts').select('*');

    if(currentCategory !== "all")
    query = query.eq("category",currentCategory);

    const { data: facts, error } = await query
    .order("votesInteresting", {ascending: false})
    .limit(1000);
    
    if(!error) setFacts(facts);
    else alert('There was a problem when loading the page :(');
    setisLoading(false);

    // setFacts(facts);

     
   }
      getFacts();


  }, [currentCategory])

  return (
    <>
    <Header showForm={showForm} setShowForm={setShowForm}/>
 
{showForm ? <NewFactForm setFacts = {setFacts} setShowForm={setShowForm}/> : null}

<main className="main">
<CategoryFilter setCurrentCategory={setCurrentCategory} />
  {isLoading ? <Loader /> : <FactList facts={facts} setFacts={setFacts}/>}


</main>
</>
);
}

function Loader() {
  return <p className ="message" >Loading..</p>
}

function Header({showForm, setShowForm}) {
  const appTitle = "Budgie Knowledge";

  return (
    <header className="header">
    <div className="logo">
      <img src="BudgieLogo.png" alt="logo" height="68" width="68" />
      <h1>{appTitle}</h1>
    </div>
  
    <button className="btn btn-large btn-open"onClick={()=>setShowForm((show) => !show)}>{showForm ? 'Close' : 'Post something:'}</button>
  </header>
  


  );
}

const CATEGORIES = [
  { name: "Budgie-food", color: "#064e3b" },
  { name: "Budgie-toys", color: "#701a75" },
  { name: "Budgie-homes", color: "#0c4a6e" },
  { name: "Budgie-training", color: "#881337" },
  
];

function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
}

function NewFactForm({setFacts, setShowForm}){
  const [text, setText] = useState("");
  const [source, setSource] = useState("");
  const [category, setCategory] = useState("");
  const [isUploading, setIsUploading] = useState(false); 
  const textLength = text.length;

 async function handleSubmit(e) {
      e.preventDefault();
      console.log(text,source,category);
      if (text && isValidHttpUrl(source) && source && category && textLength <= 200) {
        // const newFact = {
        //   id: Math.round( Math.random()*10000000),
        //   text,
        //   source,
        //   category,
        //   votesInteresting:0,
        //   votesMindblowing:0,
        //   votesFalse: 0,
        //   createdIn: new Date().getFullYear(),
        // };
          setIsUploading(true);
         const{data:newFact,error} = await       supabase.from("facts").insert([{text,source,category}]).select();
          setIsUploading(false);

        if (!error) setFacts((facts)=> [newFact[0], ...facts]);

        setText('');
        setSource('');
        setCategory('');

        setShowForm(false);
        }
      }

  

  return ( <form className ='fact-form' onSubmit ={handleSubmit}> <input type="text" placeholder="Share a fact..." 
  value={text}
  onChange={(e)=> setText(e.target.value)}/>
  <span>{200 - textLength}</span>
  <input type="text" placeholder="http://example.com"
  onChange={(e)=> setSource(e.target.value)} />

  <select value={category} onChange={(e)=> setCategory(e.target.value)}>
    <option value="">Choose category</option>
    {CATEGORIES.map((cat)=> (<option key={cat.name} value ={cat.name}>{cat.name.toUpperCase()}</option>))}
  </select>
  <button className="btn btn-large">Post</button></form>
  );
}







function CategoryFilter({setCurrentCategory}) {
  return ( <aside>
    <ul>
    <li className="category">
              <button className="btn btn-all-categories" onClick={()=>setCurrentCategory("all")}>All</button>
            </li>

    {CATEGORIES.map((cat)=> (<li key={cat.name} className="category">
  <button
    className="btn btn-category"
    style={{ backgroundColor: cat.color }}
    onClick={()=>setCurrentCategory(cat.name)}>
    {cat.name}
    </button>
</li> ))}
    
    
</ul></aside>
  );
}

function FactList({ facts, setFacts }) {
  
if(facts.length === 0) 
  return  (<p className="message">No facts for this category yet! Create your first one!</p>
  );


  return (
  <section>
    <ul className="facts-list">{facts.map((fact)=>(
    <Fact key ={fact.id}fact={fact} setFacts={setFacts}/>
   ))}</ul>
   <p>There are currently {facts.length} facts about budgies.</p>
   </section>
  );
}

function Fact({fact,setFacts}){
  const[isUpdating, setIsUpdating] = useState(false);
  const isDisputed = fact.votesInteresting+fact.votesMindblowing < fact.votesFalse;
  async function handleVote(columnName) {
    setIsUpdating(true);

     const{data:updatedFact, error} = await supabase
     .from("facts")
     .update({[columnName]: fact [columnName]+1 })
     .eq("id", fact.id)
     .select();

     setIsUpdating(false);

     if(!error) setFacts((facts)=>facts.map((f)=>f.id=== fact.id? updatedFact[0] : f))
  }

  return (
  <li className="fact">
  <p>
    {isDisputed ?  <span className="disputed">[❗DISPUTED❗]</span> :null}
    {fact.text}
    <a
      className="source"
      href={fact.source}
      target="_blank"
      >(Source)</a>
  </p>
  <span className="tag" style={{backgroundColor: CATEGORIES.find((cat)=>cat.name === fact.category).color}}
    >{fact.category} </span>
  <div className="vote-buttons">
    <button onClick={()=>handleVote("votesInteresting")} disabled={isUpdating}>👍 {fact.votesInteresting}</button>


    <button onClick={()=>handleVote("votesMindblowing")} disabled={isUpdating}>🤯 {fact.votesMindblowing}</button>
    <button onClick={()=>handleVote("votesFalse")} disabled={isUpdating}>⛔️ {fact.votesFalse}</button>
  </div>
</li>
);
}


export default App;